'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _templateObject = _taggedTemplateLiteral(['\n    .grid__item {\n      width: ', '%;\n      padding-bottom: ', '%;\n      @media(min-width: ', ') {\n        width: ', '%;\n        padding-bottom: ', '%;\n      }\n      @media(min-width: ', ') {\n        width: ', '%;\n        padding-bottom: ', '%;\n      }\n      @media(min-width: ', ') {\n        width: ', '%;\n        padding-bottom: ', '%;\n      }\n      @media(min-width: ', ') {\n        width: ', '%;\n        padding-bottom: ', '%;\n      }\n    }\n  '], ['\n    .grid__item {\n      width: ', '%;\n      padding-bottom: ', '%;\n      @media(min-width: ', ') {\n        width: ', '%;\n        padding-bottom: ', '%;\n      }\n      @media(min-width: ', ') {\n        width: ', '%;\n        padding-bottom: ', '%;\n      }\n      @media(min-width: ', ') {\n        width: ', '%;\n        padding-bottom: ', '%;\n      }\n      @media(min-width: ', ') {\n        width: ', '%;\n        padding-bottom: ', '%;\n      }\n    }\n  ']);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _lodash = require('lodash');
var _lodash2 = _interopRequireDefault(_lodash);
var _reactEmotion = require('react-emotion');
var _variables = require('../utility/variables');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var Grid = function Grid(props) {
  var smColumns = props.smColumns || props.columns;
  var mdColumns = props.mdColumns || props.smColumns || props.columns;
  var lgColumns = props.lgColumns || props.mdColumns || props.smColumns || props.columns;
  var xlColumns = props.xlColumns || props.lgColumns || props.mdColumns || props.smColumns || props.columns;
  var smHeightRatio = props.smHeightRatio || props.heightRatio;
  var mdHeightRatio = props.mdHeightRatio || props.smHeightRatio || props.heightRatio;
  var lgHeightRatio = props.lgHeightRatio || props.mdHeightRatio || props.smHeightRatio || props.heightRatio;
  var xlHeightRatio = props.xlHeightRatio || props.lgHeightRatio || props.mdHeightRatio || props.smHeightRatio || props.heightRatio;
  var gridClass = (0, _reactEmotion.css)(_templateObject, 100 / props.columns, props.heightRatio * (100 / props.columns), props.screenSm, 100 / smColumns, smHeightRatio * (100 / smColumns), props.screenMd, 100 / mdColumns, mdHeightRatio * (100 / mdColumns), props.screenLg, 100 / lgColumns, lgHeightRatio * (100 / lgColumns), props.screenXl, 100 / xlColumns, xlHeightRatio * (100 / xlColumns));
  return _react2.default.createElement('div', {
    className: 'grid ' + gridClass + ' ' + props.className
  }, _react.Children.map(props.children, function (child) {
    return _react2.default.createElement('div', {
      className: 'grid__item'
    }, _react2.default.createElement('div', {
      className: 'grid__item-inner'
    }, child));
  }));
};
Grid.defaultProps = {
  className: '',
  children: null,
  columns: 1,
  screenSm: _variables.mediaQueries.sm,
  screenMd: _variables.mediaQueries.md,
  screenLg: _variables.mediaQueries.lg,
  screenXl: _variables.mediaQueries.xl,
  smColumns: null,
  mdColumns: null,
  lgColumns: null,
  xlColumns: null,
  heightRatio: 1,
  smHeightRatio: null,
  mdHeightRatio: null,
  lgHeightRatio: null,
  xlHeightRatio: null
};
Grid.propTypes = {
  className: _propTypes2.default.string,
  children: _propTypes2.default.node,
  screenSm: _propTypes2.default.string,
  screenMd: _propTypes2.default.string,
  screenLg: _propTypes2.default.string,
  screenXl: _propTypes2.default.string,
  columns: _propTypes2.default.oneOf(_lodash2.default.range(1, 12)),
  smColumns: _propTypes2.default.oneOf(_lodash2.default.range(1, 12)),
  mdColumns: _propTypes2.default.oneOf(_lodash2.default.range(1, 12)),
  lgColumns: _propTypes2.default.oneOf(_lodash2.default.range(1, 12)),
  xlColumns: _propTypes2.default.oneOf(_lodash2.default.range(1, 12)),
  heightRatio: _propTypes2.default.number,
  smHeightRatio: _propTypes2.default.number,
  mdHeightRatio: _propTypes2.default.number,
  lgHeightRatio: _propTypes2.default.number,
  xlHeightRatio: _propTypes2.default.number
};
exports.default = Grid;